import { data } from "react-router-dom";
import axiosInstance from "./axiosInstance";
import axios from "axios";
const api = {
  login: (userData) => axiosInstance.post("/userLogin", userData),
  registerUser: (userData) => axiosInstance.post("/registerUser", userData),
  getAllProperties: () => axiosInstance.get("/getAllProperties"),
  // getPropertyById: (id) => axiosInstance.get("/getPropertyById/" + id),
  getAllPropertyType: () => axiosInstance.get("/getAllPropertyType"),
  getPropertyMarketRange: (id) =>
    axiosInstance.get(`/getPropertyMarketRange/${id}`),
  getIndependentHouseById: (id) => axiosInstance.get(`/getIndependentHouseById/${id}`),
  getApartmentPlotsById: (id) => axiosInstance.get(`/getApartmentPlotsById/${id}`),
  AddFAQ: (data) => axiosInstance.post(`/addFAQ`, data),
  getFAQs: () => axiosInstance.get(`/getFAQs`),
  deletFAQ: (id) => axiosInstance.delete(`/deleteFAQ/${id}`),

};
const vendorApi = {
  getApartments:()=>axiosInstance.get('/listApartments'),
  getPropertyCounts: () => axiosInstance.get(`/getPropertyCounts`),
  addProperty: (propertyData) =>
    axiosInstance.post("/addProperty", propertyData),
  addProject: (data) => axiosInstance.post(`/addProject`, data),
  editProject: (id, data) => axiosInstance.post(`/editProject/${id}`, data),
  editProperty: (data) => axiosInstance.post('/editProperty', data),

  viewProject: () => axiosInstance.get(`/viewProject`),
  updatePrice: (data) => axiosInstance.post(`/updateMarketPrice`, data),
  getPropertiesByVendorId: (data) =>
    axiosInstance.get(
      `/getPropertiesByVendorId/${data.vendorId}/${data.offset}/${data.limit}`
    ),
  addDocumentByAdmin: (documentData) =>
    axiosInstance.post(`/addDocumentsByAdmin`, documentData),
  addProjectDocumentsByAdmin: (documentData) => axiosInstance.post(`/addProjectDocumentsByAdmin`, documentData),
  addApartmentDocumentsByAdmin: (documentData) => axiosInstance.post(`/addApartmentDocumentsByAdmin`, documentData),
  addDocument: (documentData) =>
    axiosInstance.post(`/addDocuments`, documentData),
  addProjectDocuments: (documentData) => axiosInstance.post(`/addProjectDocuments`, documentData),
  addApartmentDocuments: (documentData) => axiosInstance.post(`/addApartmentDocuments`, documentData),
  getDocumentsById: (params) => axiosInstance.get('/getDocumentsById', { params }),
  getAllNotifications: () => axiosInstance.get("/getAllNotifications"),
  getAllMessages: () => axiosInstance.get("/getAllMessages"),
  getPropertyById: (propertyId) => axiosInstance.get("getPropertyById/" + propertyId),
  getAllProjects: () => axiosInstance.get(`/getAllProjects`),
  getAllProjectsName: () => axiosInstance.get(`/getAllProjectsName`),
  addNotification: (data) => axiosInstance.post(`/addNotification`, data),
  addReplyMessage: (data) => axiosInstance.post(`/addReplyMessage`, data),
  getProjectImages: (id) => axiosInstance.get(`/getProjectImagesById/${id}`),
  getPropertyImages: (id) => axiosInstance.get(`/getAllImages/${id}`),
  getAllVendorProperties: () => axiosInstance.get(`/getAllVendorProperties`),
  approveProperty: (propertyData) => axiosInstance.post(`/approveProperty`, propertyData),
  getAllPendingMarketPrice: () => axiosInstance.get(`/getAllPendingMarketPrice`),
  ApprovePriceUpdate: (propertyData) => axiosInstance.post(`/ApprovePriceUpdate`, propertyData),
  getAllSiteVisits: () => axiosInstance.get(`/getAllSiteVisits`),
  getProjectDetailsById: (projectId) => axiosInstance.get(`/getProjectDetailsById/${projectId}`),
  addPropertyApproval: (data) => axiosInstance.post(`/addPropertyApproval`, data),
  deleteLegalTeam: (id) =>axiosInstance.post("/deletelegalteam", {legal_team_id: id,}),

  addLegalTeamMarketUpdate: (data) => axiosInstance.post(`/addLegalTeamMarketUpdate`, data),
  addApartment: (data) => axiosInstance.post(`/addApartment`, data),
  editApartment:(id,data) => axiosInstance.post(`/editApartment/${id}`,data),
  addFlat: (data) => axiosInstance.post(`/addFlat`, data),
  getAllApartments: () => axiosInstance.get('/getAllApartments'),
  getApartmentImagesById: (id) => axiosInstance.get(`/getApartmentImagesById/${id}`),
  getApartmentDocumentsById: (id) => axiosInstance.get(`/getApartmentDocumentsById/${id}`),
  deleteDocumentById: (payload) => axiosInstance.delete(`/deleteDocumentById`, { data: payload }),
  downloadDocument: (id) =>
    axiosInstance.get(`/downloadDocument/${id}`, {
      responseType: 'blob',
    }),
  downloadProjectDocument: (id) => axiosInstance.get(`/downloadProjectDocument/${id}`, {
    responseType: 'blob',
  }),
  downloadApartmentDocument: (id) => axiosInstance.get(`/downloadApartmentDocument/${id}`, {
    responseType: 'blob',
  }),
  deleteImageById: (data) => axiosInstance.post('/deleteImageById', data),
  updatePropertyPrice: (payload) => axiosInstance.post('/updatePropertyPrice', payload),
  editVillaDetails: (data) => axiosInstance.post('/editVillaDetails', data),
  editApartmentDetails: (data) => axiosInstance.post('/editApartmentDetailsByAdmin', data),
  getSiteVisitsData: () => axiosInstance.get('/getSiteVisitsData'),
  fetchRecentProperties: () => axiosInstance.get('/fetchRecentProperties'),
  getAllSubscriptions: () => axiosInstance.get('/getAllSubscriptions'),
  approveSubscription: ({ userId, paymentId, status }) => axiosInstance.post("/approveSubscription", { userId, paymentId, status, }),
  deleteProjectLayout: (data) => axiosInstance.post(`/deleteProjectLayout`, data),
  uploadProjectLayout: (data) => axiosInstance.post(`/uploadProjectLayout`, data),

  getAllVendorSubscriptions: () => axiosInstance.get('/getAllVendorSubscriptions'),

  deteleProperty: (data) => axiosInstance.post(`/delete-property`, data),
getPropertyVideos: (data) =>
  axiosInstance.get('/getPropertyVideos', {
    params: {
      type: data.type,
      reference_id: data.reference_id,
    },
  }),

  getPropertyContactDetails: (data) =>
  axiosInstance.get('/getPropertyContactDetails', {
    params: {
      type: data.type,
      reference_id: data.reference_id,
    },
  }),

addpropertyvideos: (data) => axiosInstance.post(`/property/video/upload`, data),
addPropertyContactDetails: (data) => axiosInstance.post(`addPropertyContactDetails`, data),
editecontactdetails: (data) => axiosInstance.post(`edite-contact-details`, data),

deletepropertyvideo: (data) => {
  return axiosInstance.delete('/property-video', {
    data: data
  });
},
editFlat: (formData) =>
  axiosInstance.post("/editFlat", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }),

};
const investorApi = {
  addInvestment: (investmentData) =>
    axiosInstance.post("/investment", investmentData),
  getAllInvestments: (id) => axiosInstance.get("/getInvestorInvestments/" + id),
  processSale: (saleData) => axiosInstance.post("/processSale", saleData),

  getInvestmentRange: (id) => axiosInstance.get(`/getInvestmentRange/${id}`),
  getInvestments: (id) => axiosInstance.get(`/getAllInvestments`),
  getInvestorDetails: (id) => axiosInstance.get(`/getInvestorDetails`),
  getPaymentData: () => axiosInstance.get("/getInvestmentPaymentData"),
  getRecentInvestmentProperties: () => axiosInstance.get("/getRecentPropertyInvestments"),
  getInvestmentStats: () => axiosInstance.get('/getInvestmentStats'),
  updateInvestmentPayment: (investmentId, data) =>
    axiosInstance.post(`/updateInvestmentPayment/${investmentId}`, data),
  getPaymentScreenshot: (investmentId) => axiosInstance.get("/getPaymentScreenshot", investmentId),
  getPaymentScreenshot: (investmentId) => axiosInstance.get(`/getScreenshotPath/${investmentId}`),
  getIndividualProperties: () => axiosInstance.get("/getIndividualProperties/"),
  getProjectNames: () => axiosInstance.get("/getProjectNames/"),
  getLegalTeam: () => axiosInstance.get(`/getLegalTeam`),
  addLegalTeam: (data) => axiosInstance.post(`/addLegalTeam`, data),
  updateLegalTeam: (data) => axiosInstance.post(`/updateLegalTeam`, data),
  addThemeSetting: (data) => axiosInstance.post(`/addThemeSetting`, data),
  getAllUserDetails: () => axiosInstance.get(`getAllUserDetails`),
  getKycDetails: () => axiosInstance.get(`/getAllKycDetails`),
  updateKyc: (data) => axiosInstance.post(`/updateKYCStatus`, data),
  getAllUsers: () => axiosInstance.get("/getAllUserDetails"),
  getAllEnquiries: () => axiosInstance.get("/getAllEnquiries"),
  updateProfile: (id, userData) => axiosInstance.post(`updateProfile/${id}`, userData),
  updatePassword: (id, userData) => axiosInstance.post(`updateAdminPassword/${id}`, userData),
  addSaleToLegalTeam: (data) => axiosInstance.post(`/addSaleToLegalTeam`, data),
  markAsRead: (id) => axiosInstance.post(`markNotificationAsRead/${id}`),
  markAllMessageRead: () => axiosInstance.post(`/markAllMessageRead`),
  markAllNotificationsAsRead: () => axiosInstance.post(`/markAllNotificationsAsRead`),
  deleteNotificationById: (notificationId) => axiosInstance.delete(`deleteAdminNotificationById/${notificationId}`),
  deleteAllNotifications: () => axiosInstance.delete(`/deleteAllAdminNotifications`),
  getAllBookedProperties: () => axiosInstance.get('/getAllBookedProperties'),
  getAllDocumentRequests: () => axiosInstance.get('/getAllDocumentRequests'),
  addEditableDocuments: (data) => axiosInstance.post('/addEditableDocuments', data),
  addImagesById: (data) => axiosInstance.post(`/addImagesById`, data),
  changePasswordById: (data) => axiosInstance.post(`/changePasswordById`, data),
  approveAdvancePayment: (data) => axiosInstance.post('/approveAdvancePayment', data),
  addUser: (data) => axiosInstance.post('/addUser', data),
   getApartmentPlotsById:(id)=>axiosInstance.get(`/getApartmentPlotsById/${id}`),

};
const salesApi = {
  getSales: () => axiosInstance.get("/getAllSaleData"),
  updateSale: (data) => axiosInstance.post(`/updateSale`, data),
  getAllProjectDetails: () => axiosInstance.get(`/getAllProjectDetails`),
  getProjectProperties: (projectId) => axiosInstance.get(`/getProjectProperties/${projectId}`),
};
const settingApi = {
  getTheme: () => axiosInstance.get("/getAllTheme"),
  ThemeType: () => axiosInstance.get("/getThemeType"),
  addTheme: (data) => axiosInstance.post(`/addTheme`, data),
  addThemeType: (data) => axiosInstance.post(`/addThemeType`, data),
  generalTheme: (data) => axiosInstance.post(`/generalTheme`, data),
  addThemeColors: (data) => axiosInstance.post(`addThemeColors`, data),
  getThemeLogo: (data) => axiosInstance.get(`getThemeLogo/${data}`),
  addWebsiteThemeColors: (data) => axiosInstance.post(`addWebsiteThemeColors`, data),
  addPropertyShare: (data) => axiosInstance.post(`addPropertyShare`, data),
  getShares: () => axiosInstance.get(`getShares`),
  addSubscriptionPlan: (data) => axiosInstance.post('/addSubscriptionPlan', data),
  storeAdvertisement: (data) => axiosInstance.post('/storeAdvertisement', data),
  getAllAdvertisement: () => axiosInstance.get(`/getAllAdvertisement`),
  advertisementsDelete: (id) => axiosInstance.delete(`/advertisementsDelete/${id}`),
  themes: (data) => axiosInstance.post(`/themes`, data),
};

const walletApi = {
  getWallet: () => axiosInstance.get("/getAllWalletDetails"),
  getWalletScreenshotPath: (id) => axiosInstance.get(`/getWalletScreenshotPath/${id}`),
  updateWalletPayment: (data) => axiosInstance.post(`/updateWalletPayment`, data),
  getPaymentDetailsById: (paymentId) => axiosInstance.get(`/getPaymentDetailsById/${paymentId}`)
}
const legalTeamApi = {
  getLegalTeamPendingProperties: (userId) => axiosInstance.get(`/getLegalTeamPendingProperties/${userId}`),
  ApprovePropertyByLegal: (data) => axiosInstance.post(`/ApprovePropertyByLegal`, data),
  getNotifications: (userId) => axiosInstance.get(`/getNotifications/${userId}`),
  getUnReadNotifications: (userId) => axiosInstance.get(`/getUnReadNotifications/${userId}`),
  getLegalTeamApprovedProperties: () => axiosInstance.get('/getLegalTeamApprovedProperties'),
  getPendingMarketUpdates: (userId) => axiosInstance.get(`/getPendingMarketUpdates/${userId}`),
  approvePriceUpdateByTeam: (data) => axiosInstance.post(`/approvePriceUpdateByTeam`, data),
  getLegalTeamSaleUpdates: (userId) => axiosInstance.get(`/getLegalTeamSaleUpdates/${userId}`),
  updateSaleByTeam: (data) => axiosInstance.post(`/updateSaleByTeam`, data),
  markAllAsRead: (userId) => axiosInstance.post(`markAllAsRead/${userId}`),
  setNotificationAsRead: (notificationId) => axiosInstance.post(`/setNotificationAsRead/${notificationId}`),
  deleteNotificationById: (notificationId) => axiosInstance.delete(`/deleteNotificationById/${notificationId}`),
  deleteAllTeamNotifications: (userId) => axiosInstance.delete(`/deleteAllNotifications/${userId}`),
  markAsRead: (id) => axiosInstance.post(`/markAsRead/${id}`),
}


export default api;
export { vendorApi, investorApi, salesApi, settingApi, walletApi, legalTeamApi };
